import i18next from 'i18next'
import React from 'react'
import { GenericPageHeader } from '../sharedLayout/pageheader'
import { NavigationSection } from '../sharedLayout/navigationSection'
import { DepartmentOrCentrum as DepartmentOrCentrum } from './departmentsAndCentraOverviewState'

export const DepartmentsAndCentraOverviewLayout = (props: {
  departmentsAndCentra: DepartmentOrCentrum[]
  breadcrumbs: { title: string; url: string }[]
}) => (
  <>
    <GenericPageHeader
      kind="departmentOrCentrumOverview"
      breadcrumbs={props.breadcrumbs}
      title={i18next.t('misc:department_plural')}
    />

    <nav className="pagination--az gutter--m container--m" aria-label={i18next.t('a11y:navLabelPagination')}>
      <header className="pagination__header">
        <h2 className="pagination__title title--l">{i18next.t('misc:departmentOverviewPaginationTitle')}</h2>
      </header>
      <div className="pagination__inner">
        <ul className="pagination__list">
          {letters.map((letter) =>
            props.departmentsAndCentra.filter((department) => department.title.startsWith(letter)).length > 0 ? (
              <li className="pagination__item" key={letter}>
                <a href={`#pagination-${letter}`} className="pagination__link">
                  <span>{letter}</span>
                </a>
              </li>
            ) : (
              <li className="pagination__item pagination__item--disabled" aria-hidden="true" key={letter}>
                <span className="pagination__letter">{letter}</span>
              </li>
            )
          )}
        </ul>
      </div>
    </nav>

    <section className="sections sections--pagination sections--departments container--m gutter--m">
      {letters
        .filter(
          (letter) => props.departmentsAndCentra.filter((department) => department.title.startsWith(letter)).length > 0
        )
        .map((letter) => (
          <NavigationSection
            kind="departmentOrCentrum"
            letter={letter}
            items={props.departmentsAndCentra.filter((department) => department.title.startsWith(letter)).sort((a,b) => a.title.localeCompare(b.title))}
          />
        ))}
    </section>
  </>
)

export const letters = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
]
